import { render, staticRenderFns } from "./LiveLearn.vue?vue&type=template&id=1ef3dfaa&scoped=true"
import script from "./LiveLearn.vue?vue&type=script&lang=js"
export * from "./LiveLearn.vue?vue&type=script&lang=js"
import style0 from "./LiveLearn.vue?vue&type=style&index=0&id=1ef3dfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3dfaa",
  null
  
)

export default component.exports